import React from 'react';
import GearItemCard from './GearItemCard';
import { resolveMediaUrl } from '../../api/transport';
import './PlayerAccordionTab.css';

// Position-based color constants (matching draft system)
const POSITION_COLORS = {
  QB: '#f1c40f',        // Yellow
  RB: '#3498db',        // Blue
  WR: '#e74c3c',        // Red
};

/**
 * Gets the background color for a position badge
 * @param {string} position - The player's position (QB, RB, WR)
 * @returns {string} - CSS color value
 */
const getPositionColor = (position) => {
  return POSITION_COLORS[position] || '#2c3e50'; // Default dark color if position not found
};

function PlayerAccordionTab({
  player,
  gear,
  isExpanded,
  onTabClick,
  canModifyGear,
  onUnequip,
  teamGear,
  onTransferClick,
  isInTransferMode,
  tabState,
  transferGearId,
  swappableGearIds,
  onSwapClick
}) {
  // Determine tab class based on transfer state
  let tabStateClass = '';
  if (tabState === 'source') {
    tabStateClass = 'transfer-source';
  } else if (tabState === 'valid') {
    tabStateClass = 'transfer-valid';
  } else if (tabState === 'invalid') {
    tabStateClass = 'transfer-invalid';
  }

  return (
    <div className="accordion-tab">
      {/* Tab Header - Always Visible */}
      <div
        className={`tab-header ${isExpanded ? 'expanded' : 'collapsed'} ${tabStateClass}`}
        onClick={onTabClick}
      >
        <div className="tab-label">
          {player.position && (
            <span
              className="player-position-badge"
              style={{ backgroundColor: getPositionColor(player.position) }}
            >
              {player.position}
            </span>
          )}
          <img
            src={
              player.presentation?.image_url
                ? resolveMediaUrl(player.presentation.image_url)
                : (player.gsis_id || player.source_player_id)
                    ? `/art/player_images_gsis_cartoon/${player.gsis_id || player.source_player_id}.png`
                    : '/art/playerImgs/ExamplePlayer.png'
            }
            alt={player.name}
            className="player-tab-image"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/art/playerImgs/ExamplePlayer.png';
            }}
          />
          <span className="player-name">{player.name}</span>
        </div>
      </div>
      
      {/* Tab Content - Only visible when expanded */}
      {isExpanded && (
        <div className={`tab-content ${isInTransferMode ? 'transfer-mode' : ''}`}>
          {gear.length === 0 ? (
            <div className="no-gear-message">
              No gear equipped
            </div>
          ) : (
            gear.map((item, index) => (
              <GearItemCard
                key={item.id}
                gear={item}
                gearNumber={index + 1}
                canModifyGear={canModifyGear}
                onUnequip={onUnequip}
                teamGear={teamGear}
                onTransferClick={onTransferClick}
                isInTransferMode={isInTransferMode}
                isTransferSource={transferGearId === item.id}
                isSwappable={swappableGearIds?.includes(item.id)}
                onSwapClick={onSwapClick}
              />
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default PlayerAccordionTab;